import { api } from './_request';

export const get = () => {
	return (dispatch) => {

		api().get('/participaciones')
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'LIST',
					payload: response.data
				});
			}
		});

	}
}

export const update = (participacion, callback) => {
	return (dispatch) => {

        console.log(participacion);
		dispatch({ type: 'SAVE' });

		api().post(`participaciones/${participacion.id}`, participacion)
		.then(function(response)
		{
			if(response.status === 200)
			{
				dispatch({
					type: 'UPDATE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);
			}
			else
			{
				dispatch({ type: 'SAVE_FAILURE' });
			}
		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
}

export const save = (item, callback) => {
	return (dispatch) => {

		dispatch({ type: 'SAVE' });

		api().post('participaciones', item).then(function(response) {

			if(response.status === 200) {

                console.log( response.data);
				dispatch({
					type: 'SAVE_SUCCESS',
					payload: response.data
				});

				if(typeof callback === 'function') callback(response.data);

			}
			else{
				dispatch({ type: 'SAVE_FAILURE' });
			}

		})
		.catch(function(error) {
			dispatch({ type: 'SAVE_FAILURE' });
		});

	}
}


// WEBPACK FOOTER //
// ./src/actions/participaciones.js